import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type PartnerService from 'tio-employee/services/partner';
import type SessionContextService from 'tio-employee/services/session-context';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';

export default class AuthenticatedTasMentoringRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;
  @service declare partner: PartnerService;

  async model() {
    const { content } = (await this.store.request(
      findRecord<EmployeeModel>('employee', this.sessionContext.currentEmployee.id || '')
    )) as { content: { data: EmployeeModel } };
    const employee = content.data;

    return { employee: employee, hasSupport: this.isSupportEnabled };
  }

  get isSupportEnabled() {
    return this.partner.isAnySupportEnabled;
  }
}
